import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { ConfigProvider, notification } from 'antd';
import enUS from 'antd/es/locale/en_US';
import zhCN from 'antd/es/locale/zh_CN';
import RenderRouter from '@app/routes';
import { apiService } from './utils/api';
import { useStores } from '@app/hooks/stores';
import { lacaleConfig } from '@app/locales';
import { GlobalStyle } from '@app/themes/global';

// import 'react-notifications-component/dist/scss/notification.scss';

const App: React.FC = () => {
  // Setup error interceptor
  apiService.setResponseInterceptor(
    response => response,
    error => {
      const { response } = error;
      if (response) {
        const { data } = response;
        if (response && response.status === 403) {
          notification.warning({
            description: data.message,
            message: `You have not access to the resource on this page (${data.path})`,
            placement: 'bottomRight'
          });
        }
      } else {
        notification.error({
          message: 'Connection Error',
          description: 'Server or a network error',
          placement: 'bottomRight'
        });
      }
      return Promise.reject(error);
    }
  );

  const {
    authStore: { locale }
  } = useStores();

  // React.useEffect(() => {
  //   if (locale === 'en_US') {
  //     moment.locale('en');
  //   } else if (locale === 'zh_CN') {
  //     moment.locale('zh-cn');
  //   }
  // }, [locale]);

  const getAntdLocale = () => {
    if (locale === 'en_US') {
      return enUS;
    }
    if (locale === 'zh_CN') {
      return zhCN;
    }
  };

  return (
    <>
      <GlobalStyle />
      <ConfigProvider locale={getAntdLocale()} componentSize="middle">
        <IntlProvider locale={locale.split('_')[0]} messages={lacaleConfig[locale]}>
          <BrowserRouter>
            <RenderRouter />
          </BrowserRouter>
        </IntlProvider>
      </ConfigProvider>
    </>
  );
};

export default App;
